import {useState, useMemo} from "react";
import {useNavigate} from "react-router-dom";

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import CollectionsBookmarkOutlinedIcon from '@mui/icons-material/CollectionsBookmarkOutlined';

import Collapse from '@mui/material/Collapse';

import {HISTORY_LIBRARY} from "ultra/const/log";
import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity} from 'ultra/configs/general';
import {restorePath} from "ultra/helpers/route";
import {getUserRoles} from 'ultra/helpers/auth';
import {hasRole} from 'ultra/helpers/auth';

import DateValue from '../../../../../../../../Content/Widgets/DateValue';
import MessengerValue from '../../../../../../../../Content/Widgets/MessengerValue';

import {useGlobalCustomContext} from '../../../../../../../../../Helpers/context';
import {transferBook} from '../../../../../../../../../Helpers/library'
import {isYoursAccount} from '../../../../../../../../../Helpers/user'
import {getTelegramUser} from '../../../../../../../../../Helpers/telegram';

import {useToasterStore} from '../../../../../../../../../Stores/toster';
import {useBackdropPreloaderStore} from '../../../../../../../../../Stores/backdropPreloader';

import Preloader from '../../../../../../../../../Components/Preloaders/Preloader';
import AdaptiveDialog from '../../../../../../../../../Components/Adaptive/Dialog';

import {NODE_ACTIONS} from '../../../../../../../Reducers/node';
import {USER_ACTIONS} from '../../../../../../../../Profile/Reducers/user';

import MessageToOwner from '../MessageToOwner';

import './index.scss';

export default function ShowLinks(props) {
    const {content, history, belongsToLibrary} = props;

    const [city] = useState(getClientCity(window) || DEFAULT_CITY)

    const [requestInProgress, setRequestInProgress] = useState()
    const [openTransferBook, setOpenTransferBook] = useState(false)

    const {showPromt, showError, closeToaster} = useToasterStore();
    const {hideBackdropPreloader} = useBackdropPreloaderStore()

    const {nodeDispatch, userDispatch, userState} = useGlobalCustomContext();

    const navigate = useNavigate();

    const isOwner = useMemo(() => {
        return isYoursAccount(userState, content?._created_by);
    }, [userState, content])

    const roles = getUserRoles(userState?.user, getTelegramUser(), content)

    function handleTransferBookClose() {
        setOpenTransferBook(false)

        if (openTransferBook) {
            navigate(restorePath(content._parent))
        }
    }

    function transferBookHandler() {
        showPromt({
            snackbarMessage: 'Бажаєте передати книгу до української бібліотеки на Балі',
            onApproveHandler: () => {
                closeToaster();
                hideBackdropPreloader();

                setOpenTransferBook(true)

                setRequestInProgress(true)

                transferBook(city, content._uri)
                    .then(() => {
                        userDispatch({type: USER_ACTIONS.USER_REFRESH_START})
                        setRequestInProgress(false)
                    })
                    .catch((e) => {
                        setRequestInProgress(false)
                        showError({snackbarMessage: e.message})
                    })
            },
            onCloseHandler: () => {
                closeToaster();
                hideBackdropPreloader();
            }
        })

    }

    return <div className='links'>
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                {/* TODO: add endpoint */}
                <Button size="small" startIcon={<MenuBookOutlinedIcon />} fullWidth variant="outlined" href="https://t.me/bali_ua_library" target="_blank">Перейти до бібліотеки</Button>
            </Grid>

            <Grid item xs={12} md={6}>
                <Button size="small" startIcon={<LibraryBooksOutlinedIcon />} fullWidth variant="outlined" onClick={() => nodeDispatch({type: NODE_ACTIONS.POPUP_PAGE, data: {city, did: 'g0jb7AElHeLpnF7ezk11' }})}>Ознайомитись з правилами</Button>
            </Grid>

            {!hasRole(roles, ["library"]) && isOwner && <Grid item xs={12} md={6}>
                <Button size="small" startIcon={<CollectionsBookmarkOutlinedIcon />} fullWidth variant="outlined" onClick={transferBookHandler}>Передати книгу до бібліотеки</Button>

                {/* TRANSFER BOOK */}
                <AdaptiveDialog open={openTransferBook} onClose={handleTransferBookClose} title={`Передача книги "${content.title}"`}>
                    <Collapse in={requestInProgress}>
                        <div className="progressBlock">
                            <Preloader />
                        </div>
                    </Collapse>
                    <Collapse in={!requestInProgress}>
                        <p className="titleEmojiText titleEmojiTitle">Книга успішно зареєстрована</p>
                        <p className="titleEmoji">🙏</p>
                        <p className="titleEmojiText">Зв'яжіться з бібліотекою, щоб передати книгу</p>

                        <MessageToOwner belongsToLibrary={belongsToLibrary} book={content} onClick={handleTransferBookClose}/>
                    </Collapse>
                </AdaptiveDialog>
            </Grid>}

            {/* TODO: кнопку зробити */}
            {(history?.amount > 0) && isOwner && <Grid item xs={12}>
                <p><b>Історія книги:</b></p>
                <div className="bookHistory">
                    {history?._readed && <div className="bookHistoryGeneral">
                        <p>Книгу прочитано: {history?._readed} рази</p>
                    </div>}

                    {history.order.map(hid => {
                        return <div className="bookHistoryItem">
                            <div>
                                <DateValue value={history.list[hid]._timestamp} />
                                &nbsp;
                                <b><LibraryAction code={history.list[hid]._code} details={history.list[hid].details}/></b>
                            </div>
                            <div className="bookHistoryItemUser">
                                {history?._users?.[history.list[hid]._init_by]?.displayName}
                                &nbsp;
                                <MessengerValue messenger={history?._users?.[history.list[hid]._init_by]?.messenger} />
                            </div>
                        </div>
                    })}
                </div>
            </Grid>}
        </Grid>
    </div>
}

// TODO: перенести в спільниц код
function LibraryAction(props) {
    const {code, details} = props;
    if (code === HISTORY_LIBRARY.TRANSFER_TO_LIBRARY) return 'Передано в бібліотеку';
    if (code === HISTORY_LIBRARY.RESERVE) return 'Зарезервовано';
    if (code === HISTORY_LIBRARY.RESERVE_NOT_APPROVED) return 'Резерв не підтверджено';
    if (code === HISTORY_LIBRARY.RESERVE_APPROVED) return 'Резерв підтверджено';
    if (code === HISTORY_LIBRARY.EXTEND) return 'Строки читання продовжено на ' + details.term + ' тижнів';
    if (code === HISTORY_LIBRARY.RETURN) return 'Запит на повернення';
    if (code === HISTORY_LIBRARY.CANCEL) return 'Відміна';
    if (code === HISTORY_LIBRARY.RETURN_APPROVE) return 'Повернення підтверджено';
    return '';
}
